module.exports = {
    // Geral

    carregandoDadosParte1: 'Loading data...',
    carregandoDadosParte2: 'Please wait a few moments.',

    // Página da empresa / produto

    especies: 'Species',
    acessarSiteDaEmpresa: 'Access company website',
    empresaAmigaBemEstar: 'Animal Welfare Friendly Company',
    descricaoCertificacaoParte1: 'The purpose of certification is to accredit supply companies that are aligned with the purposes of our program, promoting, increasing and/or ensuring animal welfare through their products and/or services.',
    descricaoCertificacaoParte2: 'The market has increasingly demanded products that come from sources that respect animal welfare, from the beginning to the end of the production process. After all, this is the most sustainable path. And companies that assist the entire production chain are essential for us to increasingly have products with the Animal Welfare certificate.',
    redutor: 'Carbon Footprint Reducer Certification',
    descricaoCertificacaoRedutorParte1: 'The objective of certification is to certify products that demonstrably contribute to reducing greenhouse gas emissions in animal production.',
    descricaoCertificacaoRedutorParte2: 'The ESG agenda aims to guide actions in the Environmental, Social, and Governance areas. For the environmental sustainability of animal production — the E of the question — one of the key factors is reducing the carbon footprint. Knowledge and technology enable our sector to do its part in reducing greenhouse gas emissions.',
    fair4them: 'Fair4Them',
    descricaoCertificacaoFair4ThemParte1: 'Innovations in pet nutrition, health and welfare solutions will help meet the latest demands of responsible pet owners. Fair4Them certifications are designed to provide security in choices, based on values such as transparency, responsibility and trust.',
    descricaoCertificacaoFair4ThemParte2: 'Products and services certified as Fair4Them - Animal Welfare, whether for dogs, cats or horses, may be related to one or more domains or freedoms of Animal Welfare. Furthermore, an important point is that the analyses are based on publications and scientific articles, according to each species.',
    produtosCertificados: 'Certified products',
    certificacoesObtidas: 'Obtained certifications',
    outrasCertificacoes: 'Other certifications',
    podcasts: 'Podcasts',
    videos: 'Videos',
    imagens: 'Images',
    noticias: 'News',
    leiaMais: 'Read more',

    informacoesContato: 'Contact information',
    tipoContato: 'Contact type',
    descricao: 'Description',
    contato: 'Contact',

    voltarParaEmpresa: 'Back to company',
    categoria: 'Category',
    maisInformacoes: 'More information',
    bula: 'Leaflet',

    // BEA

    certificacaoBea: 'Animal Welfare Certification',
    descricaoCertificacaoBeaParte1: 'Our Animal Welfare Certification Program was created with the aim of ensuring that animal products that bear this seal on their packaging come from farms, ranches and breeding facilities that value animal welfare.',
    descricaoCertificacaoBeaParte2: 'The certification program, designed by us, is a private third-party certification, and was based on the rules of the World Health Organization, as well as on research developed by Brazilian and international Universities and Institutions, adapted to the reality of the farms.',

    // PS

    certificacaoPS: 'Sustainable Production Certification',
    descricaoCertificacaoPSParte1: 'The Sustainable Production certification program includes the sustainability assessment of animal protein production, the measurement of emissions associated with the production stage, and the commitment to continuous improvement regarding sustainability issues.',
    descricaoCertificacaoPSParte2: 'The entire certification process is based on a third-party audit, in which the information used to calculate indicators and the practices adopted on rural properties are evaluated. In this way, information is generated about the level of engagement in sustainable practices and aspects relevant to GHG emissions on the property, allowing the guidance of strategies for mitigation and the maintenance of sustainability commitments.',

    // DUROC

    certificacaoDuroc: 'Duroc Certification',
    descricaoCertificacaoDurocParte1: 'To reach consumers seeking differentiated products and demanding proof of origin, the DUROC Certification ensures traceability in farms and industries, enabling them to produce and market meat and meat products originating from animals with DUROC genetics.',
    descricaoCertificacaoDurocParte2: 'As a result, the end consumer can trust that they are taking home a high-quality product with a special flavor, recognized by the DUROC Seal.',

    // OVO CAIPIRA

    certificacaoOvoCaipira: 'Free-Range Egg Certification',
    descricaoCertificacaoOvoCaipiraParte1: 'The protocol developed by FairFood Certifications was based on the ABNT 16437 standard, transcribed in an applicable manner for each farm.',
    descricaoCertificacaoOvoCaipiraParte2: 'As an opportunity to stand out in the market, free-range egg certification will help you in developing commercial and marketing strategies, setting your brand apart from others.',

    pontosVendaMarca: 'Points of sale of the brand',
    verPontosVendaMarca: 'Check points of sale of the brand',
    avisoDisponibilidadePontosVenda: "Important: the availability of the brand's products will depend on the stock of the point of sale.",
    pontoVenda: 'Point of sale',
    estado: 'State',
    cidade: 'City',
    aindaNaoHaDadosParte1: 'There is no data to display yet.',
    aindaNaoHaDadosParte2: 'They will be available soon.',

    filtrarPorEstado: 'Filter by state',
    filtrarPorCidade: 'Filter by city',
    hintFiltroEstado: 'The filter only shows states where the company operates.',
    hintFiltroCidade: 'The filter only shows cities where the company operates.',
}